import axios from 'axios';

// Создаем экземпляр axios с базовыми настройками
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL, // базовый URL
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

export default axiosInstance;